export default {
  // EMPX-122: flag for WIP plan status update
  // disabled for now, as this will trigger pilotag DB soft delete/add
  // which will break during concurrency updates (results in multiple new records)
  PLAN_STATUS_UPDATE_ENABLED: false,
}
